<template>
  <div class="view view-new-game">
    <div class="bg-title-wrapper">
      <h2 class="new-game-title">{{bgTitle}}</h2>
    </div>

    <div class="centered-content">
      <transition name="fade-translate">
        <button v-if="player1 && player2 && !gameInProgress.value" class="button start-game" @click="startGame">Start Game!</button>
      </transition>
      <transition name="fade-translate">
        <div class="choose-winner" v-if="gameInProgress.value">
          <p>
            Game started at<br>
            {{humanDate(gameInProgress.timestamp)}}
          </p>
        </div>
      </transition>
    </div>

    <div class="flex-container">
      <div class="column left">
        <transition
          @enter="contentLeftEnter"
          :css="false">
          <div v-if="usersLoaded" class="player-select-wrapper">
          <div class="player-name-wrapper">
            <transition
            @enter="nameChangeEnter"
            @leave="nameChangeLeave"
            :css="false"
            mode="out-in">
              <h1 class="player-name" :key="player1.first_name">{{player1Name}}</h1>
            </transition>
          </div>
          <div class="avatar-racket-wrapper">
            <transition
              @enter="userEnter"
              :css="false">
              <div v-if="player1" :key="player1.first_name" class="player-avatar">
                <button @click="submitWinner(player1, player2)">
                    <img v-if="player1" :src="player1.profile_picture.data.url" :key="player1.first_name"/>
                </button>
              </div>
              <div v-else class="player-avatar"></div>
            </transition>
            <inline-svg name="racket-red" class="racket"></inline-svg>
          </div>
          <transition
            @enter="usersEnter"
            @leave="usersLeave"
            :css="false"
            mode="out-in">
            <ul class="users-list" v-if="usersLoaded && !gameInProgress.value && !isMobile">
              <li v-for="user in users">
                <button class="button-player-select"
                        @click="setPlayer(user['.key'], 1)"
                        :class="{'is-active': user === player1}"
                        :disabled="user === player2">
                  {{user.first_name}}
                </button>
              </li>
            </ul>
          </transition>
            <select
              name="users"
              v-model="newPlayer1"
              v-if="usersLoaded && !gameInProgress.value && isMobile">
              <option disabled :value="false">Choose Player</option>
              <option :disabled="user === player2" v-for="user in users" :value="user['.key']">{{user.first_name}}</option>
            </select>
        </div>
        </transition>
      </div>
      <div class="column right">
        <transition
          @enter="contentRightEnter"
          :css="false">
          <div v-if="usersLoaded" class="player-select-wrapper">
          <div class="player-name-wrapper">
            <transition
              @enter="nameChangeEnter"
              @leave="nameChangeLeave"
              :css="false"
              mode="out-in">
              <h1 class="player-name" :key="player2.first_name">{{player2Name}}</h1>
            </transition>
          </div>
          <div class="avatar-racket-wrapper">
            <transition
              @enter="userEnter"
              :css="false">
              <div v-if="player2" :key="player2.first_name" class="player-avatar">
                <button @click="submitWinner(player2, player1)">
                  <img v-if="player2" :src="player2.profile_picture.data.url" :key="player2.first_name"/>
                </button>
              </div>
              <div v-else class="player-avatar"></div>
            </transition>
            <inline-svg name="racket-black" class="racket"></inline-svg>
          </div>
          <ul class="users-list" v-if="usersLoaded && !gameInProgress.value && !isMobile">
            <li v-for="user in users">
              <button class="button-player-select"
                      @click="setPlayer(user['.key'], 2)"
                      :class="{'is-active': user === player2}"
                      :disabled="user === player1">
                {{user.first_name}}
              </button>
            </li>
          </ul>
          <select
            name="users"
            v-model="newPlayer2"
            v-if="usersLoaded && !gameInProgress.value && isMobile">
            <option disabled :value="false">Choose Player</option>
            <option :disabled="user === player1" v-for="user in users" :value="user['.key']">{{user.first_name}}</option>
          </select>
        </div>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>

  import firebase from 'firebase'
  import moment from 'moment'
  import {db, firebaseApp} from '@/utils/firebase'
  import {mapState} from 'vuex'
  import {TimelineMax, Bounce, Quad} from 'gsap'

  import UsersList from '@/components/UsersList'

  export default {
    components: {
      UsersList
    },
    data () {
      return {
        userID: false,
        newPlayer1: false,
        newPlayer2: false,
        usersLoaded: false,
        isMobile: false
      }
    },
    created () {
      const id = firebaseApp.auth().currentUser.uid
      this.userID = id
      const userRef = db.ref('/users/'+id);
      this.$bindAsObject('userRef', userRef)
    },
    firebase: {
      users: {
        source: db.ref('users').orderByChild('first_name'),
        readyCallback: function () {
          this.usersLoaded = true
        }
      },
      games: db.ref('games'),
      latestGame: db.ref('games').limitToLast(1),
      gameInProgress: {
        source: db.ref('game_in_progress'),
        asObject: true
      },
      totalGames: db.ref('total_games')
    },
    computed: {
      ...mapState(['user']),
      bgTitle () {
        return this.gameInProgress.value ? 'WHO WON?' : 'NEW GAME'
      },
      player1 () {
        if (this.gameInProgress.value && this.gameInProgress.players) {
          return this.users.find(user => user['.key'] === this.gameInProgress.players.player1)
        } else if (this.newPlayer1) {
          return this.users.find(user => user['.key'] === this.newPlayer1)
        } else {
          return false
        }
      },
      player2 () {
        if (this.gameInProgress.value && this.gameInProgress.players) {
          return this.users.find(user => user['.key'] === this.gameInProgress.players.player2)
        } else if (this.newPlayer2) {
          return this.users.find(user => user['.key'] === this.newPlayer2)
        } else {
          return false
        }
      },
      player1Name () {
        return this.player1 ? this.player1.first_name : 'Player1'
      },
      player2Name () {
        return this.player2 ? this.player2.first_name : 'Player2'
      }
    },
    methods: {
      humanDate (timestamp) {
        return moment(timestamp).format('MMMM Do YYYY, h:mm:ss a')
      },
      setPlayer (user, player) {
        player === 1 ? this.newPlayer1 = user : this.newPlayer2 = user
      },
      startGame () {
        this.$firebaseRefs.gameInProgress.set({
          timestamp: firebase.database.ServerValue.TIMESTAMP,
          value: true,
          players: {
            player1: this.player1['.key'],
            player2: this.player2['.key']
          }
        })
        this.$firebaseRefs.games.push({
          timestamp: firebase.database.ServerValue.TIMESTAMP,
          players: {
            player1: this.player1['.key'],
            player2: this.player2['.key']
          }
        })
        const latestGameID = this.latestGame[0]['.key']
        this.$firebaseRefs.users.child(this.player1['.key']).child('games').push(latestGameID)
        this.$firebaseRefs.users.child(this.player2['.key']).child('games').push(latestGameID)
      },
      submitWinner (winner, loser) {
        if (!this.gameInProgress.value) return false

        const latestGameID = this.latestGame[0]['.key']
        this.$firebaseRefs.users.child(winner['.key']).child('results').update({
          [latestGameID]: 1
        })
        this.$firebaseRefs.users.child(loser['.key']).child('results').update({
          [latestGameID]: 0
        })
        this.$firebaseRefs.games.child(latestGameID).update({
          winner: winner['.key']
        })

        // update total games
        this.$firebaseRefs.totalGames.transaction(function (total) {
          return (total || 0) + 1
        })
        // reset game in progress, clear players
        this.newPlayer1 = false
        this.newPlayer2 = false
        this.$firebaseRefs.gameInProgress.set({
          timestamp: false,
          value: false,
          players: {
            player1: false,
            player2: false
          }
        })
        this.$router.replace('/')
      },
      nameChangeEnter (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.from(el, 0.2, {
          y: '100%'
        })
      },
      nameChangeLeave (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.to(el, 0.2, {
          y: '100%'
        })
      },
      userEnter (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.to(el, 0.3, {
          y: -10
        })
        tl.to(el, 0.5, {
          y: 0,
          ease: Bounce.easeOut
        })
      },
      usersEnter (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.staggerFrom(el.querySelectorAll('li'), 0.3, {
          autoAlpha: 0,
          scale: 0,
          ease: Quad.easeOut
        }, 0.1)
      },
      usersLeave (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.to(el, 0.3, {
          autoAlpha: 0,
          ease: Quad.easeOut
        })
      },
      contentLeftEnter (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.from(el.querySelector('.player-name'), 0.25, {
          y: '100%',
          ease: Quad.easeOut
        })
        tl.from(el.querySelector('.player-avatar'), 0.4, {
          y: this.isMobile ? -10 : -100,
          ease: Quad.easeIn
        }, 0)
        tl.from('.racket-red', 0.3, {
          transformOrigin: '50%, 100%',
          rotation: -20
        }, 0.25)
        tl.to(el.querySelector('.player-avatar'), 0.4, {
          y: this.isMobile ? -20 : -100,
        }, 0.45)
        tl.to(el.querySelector('.player-avatar'), 1, {
          y: 0,
          ease: Bounce.easeOut
        })
        tl.staggerFrom(el.querySelectorAll('li'), 0.3, {
          autoAlpha: 0,
          scale: 0,
          ease: Quad.easeOut
        }, 0.1, 0.5)
      },
      contentRightEnter (el, done) {
        const tl = new TimelineMax({onComplete: done})
        tl.from(el.querySelector('.player-name'), 0.25, {
          y: '100%',
          ease: Quad.easeOut
        })
        tl.from(el.querySelector('.player-avatar'), 0.4, {
          y: this.isMobile ? -10 : -100,
          ease: Quad.easeIn
        }, 0)
        tl.from('.racket-black', 0.3, {
          transformOrigin: '50%, 100%',
          rotation: 20
        }, 0.25)
        tl.to(el.querySelector('.player-avatar'), 0.4, {
          y: this.isMobile ? -20 : -100,
        }, 0.45)
        tl.to(el.querySelector('.player-avatar'), 1, {
          y: 0,
          ease: Bounce.easeOut
        })
        tl.staggerFrom(el.querySelectorAll('li'), 0.3, {
          autoAlpha: 0,
          scale: 0,
          ease: Quad.easeOut
        }, 0.1, 0.5)
      }
    },
    mounted () {
      this.isMobile = window.innerWidth < 768
      this.setPlayer(this.userID, 1)
    }
  }

</script>

<style lang="scss" scoped>

  .view-new-game {
    position: relative;
    height: calc(100% - 5rem);

    @include respond-to(medium) {
      height: 100%;
    }

  }

  .bg-title-wrapper {
    @include coverer;
    z-index: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .new-game-title {
    font-family: $font-secondary;
    font-weight: 900;
    font-size: 35vmin;
    line-height: 1;
    color: rgba(#fff, 0.15);
    pointer-events: none;

    @include respond-to(large) {
      font-size: 50vmin;
    }

  }

  .flex-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    @include respond-to(large) {
      flex-direction: row;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 10px;
        height: 100%;
        margin-left: -5px;
        background-color: $color-white;
      }

    }

  }

  .column {
    position: relative;
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.left {
      background-color: $color-tertiary;
    }

    &.right {
      background-color: $color-secondary;
    }

  }

  .player-select-wrapper {
    position: relative;
    color: $color-white;
    text-align: center;
    z-index: 2;
  }

  .player-name-wrapper {
    overflow: hidden;
    line-height: 1;
  }

  .player-name {
    font-size: 4rem;
    text-transform: uppercase;
    letter-spacing: 5px;

    @include respond-to(large) {
      font-size: 10vh;
    }

  }

  .avatar-racket-wrapper {
    position: relative;
    margin-top: 1rem;
    margin-bottom: 1rem;

    @include respond-to(large) {
      padding-top: 6rem;
      margin-bottom: 3rem;
    }

    .player-avatar {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }

    .racket {
      height: 15vh;

      @include respond-to(medium) {
        height: 25vh;
      }

      @include respond-to(large) {
        height: 40vh;
      }

    }

  }

  .player-avatar {
    @include size(10rem);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8rem;
    background-color: $color-white;
    border: 5px solid $color-white;
    border-radius: 50%;
    overflow: hidden;

    @include respond-to(large) {
      @include size(12vmax);
      border: 1vmax solid $color-white;
    }

    button {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

  }

  .users-list {
    @include reset-list;
    @include list-inline;
    text-align: left;
    padding: 0 10rem;

    li {
      width: (100% / 3);
      padding: 0 .5rem 1rem .5rem;

      @include respond-to(x_large) {
        width: (100% / 6);
      }

    }

    li:not(:last-child) {
      /*padding-right: 1rem;*/
    }

  }

  .button-player-select {
    display: inline-block;
    min-width: 8rem;
    width: 100%;
    background-color: transparent;
    font-size: 1.4rem;
    color: $color-white;
    border-radius: 2rem;
    border: 2px solid;
    padding: 1rem;
    transition: background-color .3s ease(easeOutQuad);

    @include respond-to(large) {
      min-width: 10rem;
    }

    &.is-active,
    &:hover
    {
      background-color: $color-primary;
    }

    &:disabled {
      opacity: .5;
    }

  }

  // temp styles

  .centered-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  }

  .start-game {
    box-shadow: 0 3px 10px 0 rgba(#333, 0.5);

    &:active {
      transform: translateY(2px);
      box-shadow: 0 1px 10px 0 rgba(#333, 0.5);
    }

  }

  .choose-winner {
    font-family: $font-secondary;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 2px;
    color: $color-white;
  }

  select {
    border-radius: 3rem;
    color: $color-white;
    border: 2px solid $color-white;
    background-color: $color-blue-dark;
    padding: .5rem 1rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/NewGame.vue